// extracted by mini-css-extract-plugin
export var divider = "_oh-0";
export var systemMessage = "_oh-1";